import React from 'react';

const TextField = ({ name, value, placeHolder, onChange, label, disabled = false, autoComplete = 'off' }) => (
  <div>
    <label htmlFor={name}>{label}</label>
    <input
      className="insert-budget-input"
      type="text"
      name={name}
      value={value}
      onChange={onChange}
      placeHolder={placeHolder}
      disabled={disabled}
      autoComplete={autoComplete}
    />
  </div>
);


export default TextField;
